export const accessoryStocks = (state = {}, action) => {
  if (action.type === 'FETCH_ACCESSORY_STOCKS') {
    return action.payload;
  }

  if (action.type === 'CLEAR_ACCESSORY_STOCKS') {
    return [];
  }

  return state;
};

export const accessoryInventory = (state = [], action) => {
  if (action.type === 'FETCH_ACCESSORY_INVENTORY') {
    return action.payload;
  }

  if (action.type === 'CLEAR_ACCESSORY_INVENTORY') {
    return [];
  }

  return state;
};

export const accessoryInventoryStats = (state = [], action) => {
  if (action.type === 'FETCH_ACCESSORY_INVENTORY_STATS') {
    return action.payload;
  }

  if (action.type === 'CLEAR_ACCESSORY_INVENTORY_STATS') {
    return [];
  }

  return state;
};

export const accessoriesForJobchart = (state = [], action) => {
  if (action.type === 'FETCH_ACCESSORIES_FOR_JOBCHART') {
    return action.payload;
  }

  if (action.type === 'CLEAR_ACCESSORIES_FOR_JOBCHART') {
    return [];
  }

  return state;
};

export const accessoryInfo = (state = {}, action) => {
  if (action.type === 'FETCH_SINGLE_ACCESSORY_INFO') {
    return action.payload;
  }

  if (action.type === 'CLEAR_SINGLE_ACCESSORY_INFO') {
    return {};
  }

  return state;
};

export const accessoryInfoToTransfer = (state = {}, action) => {
  if (action.type === 'FETCH_SINGLE_ACCESSORY_INFO_TO_TRANSFER') {
    return action.payload;
  }

  if (action.type === 'CLEAR_SINGLE_ACCESSORY_INFO_TO_TRANSFER') {
    return {};
  }

  return state;
};

export const accessoryTransferHistory = (state = [], action) => {
  if (action.type === 'FETCH_ACCESSORY_TRANSFER_HISTORY') {
    return action.payload;
  }

  if (action.type === 'CLEAR_ACCESSORY_TRANSFER_HISTORY') {
    return [];
  }

  return state;
};

export const jobchartAccessoriesForRpo = (
  state = { productIndexes: {}, productNames: [], accessories: [] },
  action
) => {
  if (action.type === 'FETCH_JOBCHART_ACCESSORIES_FOR_RPO') {
    return action.payload;
  }

  if (action.type === 'CLEAR_JOBCHART_ACCESSORIES_FOR_RPO') {
    return { productIndexes: {}, productNames: [], accessories: [] };
  }

  return state;
};

export const accessoriesStocksForOutward = (
  state = { factories: {}, racknos: {}, stocks: {} },
  action
) => {
  if (action.type === 'FETCH_ACCESSORIES_STOCKS_FOR_OUTWARD') {
    return action.payload;
  }

  if (action.type === 'CLEAR_ACCESSORIES_STOCKS_FOR_OUTWARD') {
    return { factories: {}, racknos: {}, stocks: {} };
  }

  return state;
};

export const accessoryTransferRequestCount = (state = 0, action) => {
  if (action.type === 'FETCH_PENDING_ACCESSORY_TRANSFER_REQUEST_COUNT') {
    return action.payload;
  }

  if (action.type === 'CLEAR_PENDING_ACCESSORY_TRANSFER_REQUEST_COUNT') {
    return 0;
  }

  return state;
};
